import _defineProperty from "/Users/jacktiew/projects/vecloud-20250425/ve-cloud/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/Users/jacktiew/projects/vecloud-20250425/ve-cloud/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/jacktiew/projects/vecloud-20250425/ve-cloud/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jacktiew/projects/vecloud-20250425/ve-cloud/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/jacktiew/projects/vecloud-20250425/ve-cloud/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import { isEmpty, orderBy, get, pick, cloneDeep } from 'lodash';
import autoBind from 'auto-bind';
import { parseFireStoreDocument, parseDataAndUpload, fuseSearch } from './utils';

var FirestoreClient =
/*#__PURE__*/
function () {
  function FirestoreClient(options) {
    _classCallCheck(this, FirestoreClient);

    this.options = options;
    autoBind(this);
  }
  /**
   * Parameters format:
   * pagination: { page: {int} , perPage: {int} }
   * sort: { field: {string}, order: {string} }
   * filter: {Object} }
   */


  _createClass(FirestoreClient, [{
    key: "getList",
    value: function () {
      var _getList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(resource, params) {
        var filter, sort, pagination, ref, q, _filter, dateValue, today, snapshots, data, _q, value, keys, field, _sort$order, order, dataPage, page, perPage, pageStart, pageEnd, total;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                filter = params.filter, sort = params.sort, pagination = params.pagination;
                ref = firebase.firestore().collection(resource);

                if (!isEmpty(filter)) {
                  _filter = cloneDeep(filter);

                  if (resource == 'transactions' && !filter.date) {
                    today = new Date();

                    if (!filter.client) {
                      //admin, get daily data
                      today.setHours(0, 0, 0, 0);
                      dateValue = today.getTime();
                    } else {
                      //client, get monthly data
                      today.setDate(1);
                      today.setHours(0, 0, 0, 0);
                      dateValue = today.getTime();
                    }

                    _filter.date = [{
                      isDate: true,
                      operator: '>=',
                      value: dateValue
                    }];
                  }

                  Object.keys(_filter).forEach(function (key) {
                    var keyValue = _filter[key];
                    if (keyValue === undefined) return; // q is search key and searching is implemented with js search at below
                    // due to firestore text search limitation.

                    if (key === 'q') {
                      q = keyValue;
                      return;
                    }

                    if (['string', 'number', 'boolean'].includes(typeof keyValue)) {
                      ref = ref.where(key, '==', keyValue);
                    } else {
                      //if filtered by date, the typeof keyValue is Array
                      var operations = Array.isArray(keyValue) ? keyValue : [keyValue];
                      operations.forEach(function (operation) {
                        var operator = operation.operator,
                            value = operation.value,
                            isDate = operation.isDate;
                        ref = ref.where(key, operator, isDate ? new Date(value) : value);
                      });
                    }
                  });
                }

                _context.next = 5;
                return ref.get();

              case 5:
                snapshots = _context.sent;
                data = snapshots.docs.map(function (doc) {
                  return parseFireStoreDocument(doc);
                });

                if (get(q, 'value') && get(q, 'keys')) {
                  _q = q, value = _q.value, keys = _q.keys;

                  if (value !== '' && value != null) {
                    data = fuseSearch(value, keys, data);
                  }
                }

                if (!isEmpty(sort)) {
                  field = sort.field, _sort$order = sort.order, order = _sort$order === void 0 ? '' : _sort$order;
                  data = orderBy(data, [field], [order.toLowerCase()]);
                }

                dataPage = data;

                if (!isEmpty(pagination)) {
                  page = pagination.page, perPage = pagination.perPage;
                  pageStart = (page - 1) * perPage;
                  pageEnd = pageStart + perPage;
                  dataPage = data.slice(pageStart, pageEnd);
                }

                total = data.length;
                return _context.abrupt("return", {
                  data: dataPage,
                  total: total
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getList(_x, _x2) {
        return _getList.apply(this, arguments);
      }

      return getList;
    }()
    /**
     * Parameters format:
     * id: {mixed}
     */

  }, {
    key: "getOne",
    value: function () {
      var _getOne = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(resource, params) {
        var id, doc;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = params.id;
                _context2.next = 3;
                return firebase.firestore().collection(resource).doc(id).get();

              case 3:
                doc = _context2.sent;

                if (doc.exists) {
                  _context2.next = 6;
                  break;
                }

                throw new Error('No id found matching: ' + id);

              case 6:
                return _context2.abrupt("return", {
                  data: parseFireStoreDocument(doc)
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getOne(_x3, _x4) {
        return _getOne.apply(this, arguments);
      }

      return getOne;
    }()
    /**
     * Parameters format:
     * ids: {mixed[]}
     */

  }, {
    key: "getMany",
    value: function () {
      var _getMany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(resource, params) {
        var _this = this;

        var ids, promises, results, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                ids = params.ids;
                promises = ids.map(function (id) {
                  return _this.getOne(resource, {
                    id: id
                  }).catch(function () {});
                });
                _context3.next = 4;
                return Promise.all(promises);

              case 4:
                results = _context3.sent;
                data = results.map(function (result) {
                  return get(result, 'data', {});
                });
                return _context3.abrupt("return", {
                  data: data
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getMany(_x5, _x6) {
        return _getMany.apply(this, arguments);
      }

      return getMany;
    }()
    /**
     * Parameters format:
     * target: {string}
     * id: {mixed}
     * pagination: { page: {int} , perPage: {int} }
     * sort: { field: {string}, order: {string} }
     * filter: {Object} }
     */

  }, {
    key: "getManyReference",
    value: function () {
      var _getManyReference = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(resource, params) {
        var target, id;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                target = params.target, id = params.id;

                if (target) {
                  if (isEmpty(params.filter)) params.filter = {};
                  params.filter[target] = id;
                }

                _context4.next = 4;
                return this.getList(resource, params);

              case 4:
                return _context4.abrupt("return", _context4.sent);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getManyReference(_x7, _x8) {
        return _getManyReference.apply(this, arguments);
      }

      return getManyReference;
    }()
    /**
     * Parameters format:
     * id: {mixed}
     * data: {Object}
     * previousData: {Object}
     */

  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(resource, params) {
        var redundantUpdate, updatedAt, id, data, collectionRef, docRef, newData, _redundantUpdate$reso, query, source, target, sourceData, batch, targets, doc, docData;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                redundantUpdate = this.options.redundantUpdate || {};
                updatedAt = this.options.timestampFieldNames.updatedAt;
                id = params.id, data = params.data;
                delete data.id;
                collectionRef = firebase.firestore().collection(resource);
                docRef = collectionRef.doc(id);
                _context5.t0 = _objectSpread;
                _context5.t1 = {};
                _context5.next = 10;
                return parseDataAndUpload(collectionRef, id, data);

              case 10:
                _context5.t2 = _context5.sent;
                _context5.t3 = _defineProperty({}, updatedAt, firebase.firestore.FieldValue.serverTimestamp());
                newData = (0, _context5.t0)(_context5.t1, _context5.t2, _context5.t3);

                if (isEmpty(redundantUpdate[resource])) {
                  _context5.next = 27;
                  break;
                }

                _redundantUpdate$reso = redundantUpdate[resource], query = _redundantUpdate$reso.query, source = _redundantUpdate$reso.source, target = _redundantUpdate$reso.target;
                sourceData = pick(newData, source);
                batch = firebase.firestore().batch();

                if (isEmpty(sourceData)) {
                  _context5.next = 22;
                  break;
                }

                _context5.next = 20;
                return query(id).get();

              case 20:
                targets = _context5.sent;
                targets.docs.forEach(function (doc) {
                  batch.set(doc.ref, _defineProperty({}, target, sourceData), {
                    merge: true
                  });
                });

              case 22:
                batch.update(docRef, newData);
                _context5.next = 25;
                return batch.commit();

              case 25:
                _context5.next = 29;
                break;

              case 27:
                _context5.next = 29;
                return docRef.update(newData);

              case 29:
                _context5.next = 31;
                return docRef.get();

              case 31:
                doc = _context5.sent;
                docData = parseFireStoreDocument(doc);
                return _context5.abrupt("return", {
                  data: _objectSpread({}, newData, {}, docData, {
                    id: id
                  })
                });

              case 34:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function update(_x9, _x10) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
    /**
     * Parameters format:
     * ids: {mixed[]}
     * data: {Object}
     */

  }, {
    key: "updateMany",
    value: function () {
      var _updateMany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(resource, params) {
        var _this2 = this;

        var ids, data, results;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                ids = params.ids, data = params.data;
                _context6.next = 3;
                return Promise.all(ids.map(function (id) {
                  return _this2.update(resource, {
                    id: id,
                    data: data
                  });
                }));

              case 3:
                results = _context6.sent;
                return _context6.abrupt("return", {
                  data: results.map(function (result) {
                    return result.data.id;
                  })
                });

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function updateMany(_x11, _x12) {
        return _updateMany.apply(this, arguments);
      }

      return updateMany;
    }()
    /**
     * Parameters format:
     * data: {Object}
     */

  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(resource, params) {
        var _objectSpread3;

        var _this$options$timesta, createdAt, updatedAt, data, ref, id, newData;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this$options$timesta = this.options.timestampFieldNames, createdAt = _this$options$timesta.createdAt, updatedAt = _this$options$timesta.updatedAt;
                data = params.data;
                ref = firebase.firestore().collection(resource);
                id = data && data.id || ref.doc().id;
                _context7.t0 = _objectSpread;
                _context7.t1 = {};
                _context7.next = 8;
                return parseDataAndUpload(ref, id, params.data);

              case 8:
                _context7.t2 = _context7.sent;
                _context7.t3 = (_objectSpread3 = {}, _defineProperty(_objectSpread3, createdAt, firebase.firestore.FieldValue.serverTimestamp()), _defineProperty(_objectSpread3, updatedAt, firebase.firestore.FieldValue.serverTimestamp()), _objectSpread3);
                newData = (0, _context7.t0)(_context7.t1, _context7.t2, _context7.t3);
                _context7.next = 13;
                return ref.doc(id).set(newData);

              case 13:
                return _context7.abrupt("return", {
                  data: _objectSpread({}, newData, {
                    id: id
                  })
                });

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function create(_x13, _x14) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
    /**
     * Parameters format:
     * id: {mixed}
     * previousData: {Object}
     */

  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(resource, params) {
        var id;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                id = params.id;
                _context8.next = 3;
                return firebase.firestore().collection(resource).doc(id).delete();

              case 3:
                return _context8.abrupt("return", {
                  data: id
                });

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function _delete(_x15, _x16) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
    /**
     * Parameters format:
     * ids: {mixed[]}
     */

  }, {
    key: "deleteMany",
    value: function () {
      var _deleteMany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(resource, params) {
        var ids, batch;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                ids = params.ids;
                batch = firebase.firestore().batch();
                ids.forEach(function (id) {
                  return batch.delete(firebase.firestore().collection(resource).doc(id));
                });
                _context9.next = 5;
                return batch.commit();

              case 5:
                return _context9.abrupt("return", {
                  data: ids
                });

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function deleteMany(_x17, _x18) {
        return _deleteMany.apply(this, arguments);
      }

      return deleteMany;
    }()
  }]);

  return FirestoreClient;
}();

export default FirestoreClient;